export default {
    root: {
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        background: 'radial-gradient(125.46% 125.46% at 50% -6.01%, #FFFFFF 0%, #E9ECF1 39.9%, #CFD6DE 84.13%)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
    },
    backgroundOverlay: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '1727px',
        height: '702px',
        backgroundImage: 'url(/img/hedgex/Hedgex-background.png)',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        zIndex: 0,
        pointerEvents: 'none',
        // 1283 breakpoint
        '@media screen and (max-width: 1722px)': {
            top: '44%',
            left: '70%',
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            top: '33%',
            left: '70%',
        },

    },
    
    // Header Section
    header: {
        position: 'relative',
        zIndex: 10,
        padding: '50px 70px',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            padding: '30px 40px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            padding: '20px'
        }
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
    },
    rbcLogo: {
        height: '48px',
        width: 'auto',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            height: '40px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            height: '36px'
        }
    },
    languageButton: {
        '&.MuiButton-root': {
            color: '#003168',
            fontSize: '13.33px',
            fontFamily: 'Roboto',
            fontWeight: 400,
            textTransform: 'uppercase',
            '&:hover': {
                backgroundColor: 'transparent'
            }
        }
    },
    languageIcon: {
        marginRight: '8px',
        fontSize: '20px',
        color: '#003168'
    },

    // Main Content Section - centered container
    mainContent: {
        position: 'relative',
        zIndex: 10,
        width: '1529px',
        height: '495px',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible',
        '& .MuiGrid-container': {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            marginLeft: '0 !important',
            marginTop: '0 !important',
            width: '100% !important',
            justifyContent: 'center',
            alignItems: 'center'
        },
        // 1723x1080 breakpoint
        '@media screen and (max-width: 1919px)': {
            width: '1529px',
            height: '495px'
        },
        // 1283 breakpoint
        '@media screen and (max-width: 1722px)': {
            width: '958px',
            height: 'auto',
            flexWrap: 'wrap',
            marginTop: '50px',

        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '100%',
            maxWidth: '834px',
            padding: '0 40px',
            flexDirection: 'column',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '32px',
            height: 'auto',
            '& .MuiGrid-container': {
                flexDirection: 'column',
                flexWrap: 'wrap',
                alignItems: 'center'
            }
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            padding: '0 20px',
            gap: '24px'
        }
    },

    // Animated background container
    animatedBackground: {
        position: 'absolute',
        top: '30%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '140%',
        height: '180%',
        zIndex: 0,
        pointerEvents: 'none',
        contain: 'paint',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            top: '40%',
            width: '180%',
            height: '150%'
        }
    },

    // Left Section - welcomeContainer
    welcomeContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '32px',
        width: '462px',
        height: '495px',
        flexShrink: 0,
        marginRight: '78px',
        // 1723x1080 - same as 1920
        '@media screen and (max-width: 1919px)': {
            width: '462px',
            height: '495px'
        },
        // 1283 breakpoint
        '@media screen and (max-width: 1722px)': {
            width: '416px',
            height: 'auto',
            gap: '28px'
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '416px',
            maxWidth: '100%',
            height: 'auto',
            gap: '24px',
            margin: '0 auto'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            width: '401px',
            maxWidth: '100%',
            gap: '20px'
        }
    },

    // Right Section wrapper
    rightSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flexShrink: 0,
        // 1283 breakpoint
        '@media screen and (max-width: 1722px)': {
            width: '100%',
            flexBasis: '100%',
            alignItems: 'center',
            order: 1
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '100%',
            alignItems: 'center'
        }
    },

    welcomeText: {
        width: '100%',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '28px',
        textAlign: 'center',
        color: '#003168',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            fontSize: '14px',
            lineHeight: '24px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            fontSize: '13px',
            lineHeight: '22px'
        }
    },
    hedgexLogoContainer: {
        width: '424px',
        height: '88px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            maxWidth: '100%',
            height: 'auto'
        },
        // 1283 breakpoint
        '@media screen and (max-width: 1722px)': {
            width: '380px',
            height: '80px'
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '320px',
            height: '70px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            width: '100%',
            maxWidth: '280px',
            height: '60px'
        }
    },
    loginButton: {
        '&.MuiButton-root': {
            width: '400px',
            height: '52px',
            backgroundColor: '#FED001',
            borderRadius: '4px',
            color: '#003168',
            fontFamily: 'Roboto',
            fontWeight: 600,
            fontSize: '16px',
            letterSpacing: '0.46px',
            textTransform: 'capitalize',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: '#E5BC01',
                boxShadow: 'none'
            },
            // 1283 breakpoint
            '@media screen and (max-width: 1722px)': {
                width: '380px',
                height: '50px',
                fontSize: '15px'
            },
            // 834 breakpoint
            '@media screen and (max-width: 1282px)': {
                width: '100%',
                maxWidth: '380px',
                height: '48px',
                fontSize: '15px'
            },
            // 440 breakpoint
            '@media screen and (max-width: 440px)': {
                maxWidth: '100%',
                height: '44px',
                fontSize: '14px'
            }
        }
    },
    linksContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        width: '230px',
        '@media screen and (max-width: 440px)': {
            width: '100%'
        }
    },
    poweredByText: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '28px',
        textAlign: 'center',
        color: '#003168'
    },
    digitalMarketplaceText: {
        fontFamily: 'RBC Display, Roboto, sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '25px',
        lineHeight: '100%',
        letterSpacing: '0px',
        textAlign: 'center',
        color: '#003168',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            fontSize: '22px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            fontSize: '20px'
        }
    },
    dividerLine: {
        width: '399px',
        height: '0px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        flex: 'none',
        flexGrow: 0,
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '320px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            width: '100%'
        }
    },
    assistanceContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0px',
        gap: '16px',
        width: '399px',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '100%',
            maxWidth: '320px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            maxWidth: '100%',
            gap: '12px'
        }
    },
    assistanceTitleWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    assistanceTitle: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '135%',
        textAlign: 'center',
        letterSpacing: '0.3%',
        color: '#003168',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            fontSize: '15px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            fontSize: '14px'
        }
    },
    assistanceContactWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '4px'
    },
    assistanceBody: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '175%',
        textAlign: 'center',
        letterSpacing: '0px',
        '@media screen and (max-width: 440px)': {
            fontSize: '13px'
        }
    },
    contactLabel: {
        color: '#60666D'
    },
    contactValue: {
        color: '#0062BF',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    },

    // First Card Wrapper - stays in row with welcomeContainer
    firstCardWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginRight: '40px',
        '@media screen and (max-width: 1722px)': {
            marginRight: '0px',
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '100%',
            justifyContent: 'center'
        }
    },

    // Second Card Wrapper - goes to next row at 1283px and centers, image only for smaller screens
    secondCardWrapper: {
        display: 'flex',
        alignItems: 'center',
        // 1283 breakpoint - goes to next line, only image no card
        '@media screen and (max-width: 1722px)': {
            width: '643px',
            height: '365px',
            flexBasis: '100%',
            justifyContent: 'center',
            marginTop: '129px'
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '450px',
            height: '256px',
            justifyContent: 'center',
            marginTop: '60px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            width: '382px',
            height: '218px',
            maxWidth: '100%'
        }
    },

    // Glass Card for second/preview card - transparent on smaller screens
    secondCardGlassCard: {
        position: 'relative',
        boxSizing: 'border-box',
        width: '416px',
        height: '441px',
        padding: '40px',
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 59.13%, rgba(255, 255, 255, 0.1) 100%)',
        border: '1px solid rgba(229, 229, 229, 0.5)',
        boxShadow: '0px 4px 20px 0px #0000000D',
        backdropFilter: 'blur(15px)',
        borderRadius: '8px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'visible',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: '8px',
            padding: '1px',
            background: 'linear-gradient(146.68deg, #E5E5E5 -0.88%, #47525F 52.98%, #CCCCCC 100.57%)',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude',
            pointerEvents: 'none'
        },
        // 1283 breakpoint - transparent, no card effect
        '@media screen and (max-width: 1722px)': {
            width: '643px',
            height: '340px',
            background: 'transparent',
            border: 'none',
            boxShadow: 'none',
            backdropFilter: 'none',
            padding: 0,
            '&::before': {
                display: 'none'
            }
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '450px',
            height: '256px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            width: '382px',
            height: '218px',
            maxWidth: '100%'
        }
    },

    // Glass Cards - 416x441 each for 1920, 1723, 1283
    glassCard: {
        position: 'relative',
        boxSizing: 'border-box',
        width: '416px',
        height: '441px',
        padding: '41px',
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 59.13%, rgba(255, 255, 255, 0.1) 100%)',
        border: '1px solid rgba(229, 229, 229, 0.5)',
        boxShadow: '0px 4px 20px 0px #0000000D',
        backdropFilter: 'blur(15px)',
        borderRadius: '8px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: '8px',
            padding: '1px',
            background: 'linear-gradient(146.68deg, #E5E5E5 -0.88%, #47525F 52.98%, #CCCCCC 100.57%)',
            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'xor',
            maskComposite: 'exclude',
            pointerEvents: 'none'
        },
        // 1723x1080 - same as 1920
        '@media screen and (max-width: 1919px)': {
            width: '416px',
            height: '441px'
        },
        // 1283 breakpoint - same dimensions
        '@media screen and (max-width: 1722px)': {
            width: '416px',
            height: '441px'
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            width: '416px',
            height: '348px',
            padding: '32px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            width: '401px',
            height: '348px',
            maxWidth: '100%',
            padding: '24px'
        }
    },
    cardTitle: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '24px',
        lineHeight: '40px',
        letterSpacing: '-0.5px',
        color: '#003168',
        marginBottom: '8px',
        // 1723, 1283 - same as 1920
        '@media screen and (max-width: 1722px)': {
            fontSize: '24px',
            lineHeight: '40px'
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            fontSize: '22px',
            lineHeight: '36px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            fontSize: '20px',
            lineHeight: '32px'
        }
    },
    cardDescription: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '30px',
        color: '#003168',
        // 1723, 1283 - same as 1920
        '@media screen and (max-width: 1722px)': {
            fontSize: '16px',
            lineHeight: '28px'
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            fontSize: '15px',
            lineHeight: '26px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            fontSize: '14px',
            lineHeight: '24px'
        }
    },

    // Laptop Preview Container
    previewContainer: {
        position: 'absolute',
        width: '507px',
        height: '288.11px',
        top: '50%',
        left: '41%',
        transform: 'translate(-30%, -50%)',
        zIndex: 2,
        // 1723 breakpoint - same as 1920
        '@media screen and (max-width: 1919px)': {
            width: '507px',
            height: '288.11px'
        },
        // 1283 breakpoint - no card, centered image
        '@media screen and (max-width: 1722px)': {
            position: 'relative',
            width: '643px',
            height: '349.76px',
            top: 'auto',
            left: 'auto',
            transform: 'none',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            position: 'relative',
            width: '450px',
            height: '256px',
            top: 'auto',
            left: 'auto',
            transform: 'none',
            margin: '0 auto'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            width: '382px',
            height: '218px',
            maxWidth: '100%'
        }
    },
    previewDesktop: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        '@media screen and (max-width: 1722px) and (min-width: 1283px)': {
            width: '643px',
            height: '349.76px',
        },

    },
    // Footer Section - position: 60px left, 1020px top
    footer: {
        position: 'relative',
        zIndex: 10,
        padding: '24px 60px',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            padding: '20px 40px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            padding: '16px 20px',
            flexDirection: 'column',
            gap: '12px'
        }
    },
    footerCopyright: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '40px',
        letterSpacing: '0.1px',
        color: 'rgba(0, 0, 0, 0.7)',
        // 834 breakpoint
        '@media screen and (max-width: 1282px)': {
            fontSize: '13px',
            lineHeight: '24px'
        },
        // 440 breakpoint
        '@media screen and (max-width: 440px)': {
            fontSize: '12px',
            lineHeight: '20px',
            textAlign: 'left'
        }
    },
    // Additional utility styles
    link: {
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 400,
        color: '#003168',
        '&:hover': {
            color: '#006AC3'
        }
    }
}
